
export default {
  'RECONECTING_TIME': 3000,
  'SOMETHING_WRONG_TIME' : 12000,
}


// WEBPACK FOOTER //
// ./src/App/utils/TimerConfig.js